var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tier)?_c(_vm.tier,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }